// This file contains functions to push events to the data layer for Google Tag Manager (GTM) or other analytics tools.
const pushToDataLayer = (object) => {
  window.dataLayer.push(object);
};

const pushInteractionToDatalayer = ({
  action,
  category,
  event,
  label,
  value = undefined
}) => {
  const interaction = {
    event,
    interaction_action: action,
    interaction_category: category,
    interaction_label: label
  };

  if (value) {
    interaction.interaction_value = value;
  }

  pushToDataLayer(interaction);
};
export const trackProductDescriptionPageAccordionClick = (
  accordionName,
  isExpanded
) => {
  pushInteractionToDatalayer({
    action: 'click',
    category: 'product details page',
    event: 'interaction',
    label: `product ${accordionName}`,
    value: isExpanded ? 'collapse' : 'expand'
  });
};

export const trackProductDescriptionSurveyClick = (surveyId) => {
  pushInteractionToDatalayer({
    action: 'click',
    category: 'product details page',
    event: 'pdp_interaction',
    label: 'product description survey',
    value: surveyId
  });
};

export const trackProductPreviewPDPView = (productId) => {
  pushToDataLayer({
    event: 'pdp_interaction',
    interaction_action: 'pdp view',
    interaction_category: 'new',
    product_style_id: productId
  });
};

export const trackPDPComingSoonFormSubmit = (productId) => {
  pushToDataLayer({
    event: 'pdp_interaction',
    interaction_action: 'submit',
    interaction_category: 'new',
    interaction_label: 'notify me',
    product_style_id: productId
  });
};

export const trackPDPComingSoonValidationError = (productId) => {
  pushToDataLayer({
    event: 'pdp_error',
    failure_message: 'invalid email',
    product_style_id: productId
  });
};

export const trackPDPComingSoonServerError = (productId) => {
  pushToDataLayer({
    event: 'pdp_error',
    failure_message: 'coming soon form server error',
    product_style_id: productId
  });
};

export const trackPDPComingSoonNotficationRequested = (productId) => {
  pushToDataLayer({
    event: 'pdp_interaction',
    interaction_action: 'click',
    interaction_label: 'notify me when product is available',
    product_style_id: productId
  });
};

export const firePdpInteractionClickEvent = (clickSection, clickLink) => {
  window.dataLayer.push({
    click_link: clickLink,
    click_section: clickSection,
    event: 'pdp_interaction'
  });
};

export const fireAbTestViewEvent = (testName, location, group) => {
  window.dataLayer.push({
    ab_test_group: group,
    ab_test_location: location,
    ab_test_name: testName,
    event: 'ab_test_group'
  });
};
